"use client";

import { handleBlogScroll } from "@/app/utils/scroll";

interface Heading {
  text: string;
  id: string;
}

interface BlogTOCProps {
  headings: Heading[];
}

export default function BlogTOC({ headings }: BlogTOCProps) {
  if (headings.length === 0) return null;

  return (
    <div className="w-full flex flex-col gap-y-3 rounded-xl p-6 bg-ink-soft border-l-4 border-l-primary">
      {headings.map((heading, index) => (
        <p key={heading.id} className="flex items-baseline gap-2 text-sm text-zinc-400">
          {index + 1}.{" "}
          <button
            onClick={(e) => {
              e.preventDefault();
              handleBlogScroll(heading.id);
            }}
            className="text-primary hover:text-white font-medium text-left"
          >
            {heading.text}
          </button>
        </p>
      ))}
    </div>
  );
}
